let configCache = null;

export const getConfig = async () => {
  if (configCache) return configCache;

  // Always fetch from public root
  const configPath = `/config.json`;

  console.log("🔍 Loading config from:", configPath);

  const response = await fetch(configPath, { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`❌ Cannot load config from ${configPath} (status: ${response.status})`);
  }

  configCache = await response.json();
  return configCache;
};

export const getApiBaseUrl = async () => {
  const config = await getConfig();
  return config.apiBaseUrl;
};

export const getRazorpayKeyId = async () => {
  const config = await getConfig();
  return process.env.REACT_APP_RAZORPAY_KEY_ID || config.razorpayKeyId || "";
};
